"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fetchClient_1 = require("../client/fetchClient");
const getEventsFromDayOneApiResponse_1 = require("../utils/getEventsFromDayOneApiResponse");
const toErrorMessage_1 = __importDefault(require("../utils/toErrorMessage"));
const useCandidateInfo = (props, invokedFromOutside = false) => {
    const { baseUrl, employeeId, authenticatedRequestHeaders, telemetry, useQuery, log, isSpoofing, } = props;
    const apiPath = `/getDayOneInfo?employeeId=${employeeId}`;
    const url = `${baseUrl}${apiPath}`;
    let errorMessage;
    // @ts-ignore
    const result = useQuery(['GetDayOneInfo', apiPath], () => (0, fetchClient_1.FetchClientGet)(url, fetchClient_1.AtoZClientId.ATOZ_PRE_HIRE, authenticatedRequestHeaders, telemetry), {
        staleTime: 60000,
        refetchOnMount: true,
        retry: 2,
        refetchOnReconnect: true,
        retryOnMount: true,
    });
    log === null || log === void 0 ? void 0 : log.debug('useQuery result', {
        useQueryResult: result,
    });
    if (result.isError) {
        errorMessage = `Getting DayOneInfo data failed with status: ${result.status} and `
            + `error: ${result.error}`;
        log === null || log === void 0 ? void 0 : log.error(`GetDayOne Info API ERROR: ${(0, toErrorMessage_1.default)(result.error)}`, {
            error: result.error,
        });
        telemetry === null || telemetry === void 0 ? void 0 : telemetry.meter.createErrorCounter('GetDayOneInfoDataApi').submit(errorMessage);
    }
    let invalidData = false;
    let eventInfo = [];
    try {
        eventInfo = (0, getEventsFromDayOneApiResponse_1.getEventsFromDayOneApiResponse)(result.data, telemetry, isSpoofing);
    }
    catch (e) {
        errorMessage = e.message;
        log === null || log === void 0 ? void 0 : log.error(`GetDayOne Info parsing error: ${(0, toErrorMessage_1.default)(e)}`, {
            error: e,
        });
        telemetry === null || telemetry === void 0 ? void 0 : telemetry.meter.createErrorCounter('DataParsingIssue').submit(errorMessage);
        if (invokedFromOutside) {
            invalidData = true;
        }
        else {
            throw e;
        }
    }
    return {
        isError: result.isError,
        errorMessage,
        isLoading: result.isLoading,
        eventInfo,
        refetch: result.refetch,
        invalidData,
    };
};
exports.default = useCandidateInfo;
//# sourceMappingURL=useCandidateInfo.js.map